import styled from "styled-components";


import { COLORS } from 'theme'

export const Container = styled.div`
 width: auto;

 display: flex;
 justify-content: space-evenly;
 align-items: center;
`;

export const From = styled.div`
 font-weight: 500;
 font-size: 12px;
 line-height: 15px;
 text-align: center;
 color: ${COLORS.PRIMARY};
`;

export const On = styled.div`
font-weight: 500;
font-size: 12px;
 line-height: 15px;
 text-align: center;
 color: ${COLORS.GREY_T_60};
`;

export const Slash = styled.div`
color: ${COLORS.GREY_T_60}`;
